import { Accordion } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SelectBox from "elements/SelectBox";
import InputBox from "elements/InputBox";
import Pagination from "elements/Pagination";
import DateSelector from "elements/DateSelector";
import NoRecordsFound from "elements/NoRecordsFound";
import api from "services/api";
import Translator, { __ } from "services/Translator";
import PageHeadline from "../PageHeadline";

export default function TransactionHistory(props) {
  const defaultForm = {
    historyFor: "Deposits",
    startDate: null,
    endDate: null,
    page: 1,
    triggerSearch: true,
  };
  const [results, setResults] = useState([]);
  const [form, setForm] = useState(defaultForm);
  const [pagination, setPagination] = useState([]);
  const updateForm = (value, field) => {
    setForm({ ...form, [field]: value });
  };

  const getResults = async () => {
    props.setSpinner(true);
    var response = await api.post("/history/transactions", form);
    props.setSpinner(false);
    if (response.status === 200) {
      setResults(response.data.data);
      setPagination(response.data.paginationData);
    } else {
      props.showAlert(null, response.data.message, true);
    }
    updateForm(false, "triggerSearch"); //Ready for next trigger
  };

  useEffect(() => {
    if (form.triggerSearch) {
      getResults();
    }
  }, [form.triggerSearch]);

  const doReset = () => {
    setForm(defaultForm);
  };

  const [exportModal, setExportModal] = useState(false);
  const toggleExportModal = () => {
    setExportModal(!exportModal);
  };

  const onPageChange = (page) => {
    setForm({ ...form, page: page, triggerSearch: true });
  };

  const depositOrWithdrawal = [
    { label: __("Purchases"), value: "Deposits" },
    { label: __("Redeems"), value: "Withdrawals" },
    { label: __("All"), value: "All" },
  ];

  const d = new Date();
  let year = d.getFullYear();
  return (
    <>
      <PageHeadline page_name={__("Transaction History")} />
      <div className="page_content_area">
        <div className="row">
          <div className="col-12 col-lg-4">
            <div className="input_item">
              <div className="name">
                <i className="far fa-folder-open"></i> {__("Transaction For")}
              </div>
              <SelectBox
                className="form-control name_value"
                value={form.historyFor}
                onChange={(itemValue) => updateForm(itemValue, "historyFor")}
                items={depositOrWithdrawal}
              />
            </div>
          </div>
          <div className="col-12 col-lg-4">
            <div className="input_item">
              <div className="name">
                <i className="far fa-calendar-alt"></i> {__("Start Day")}
              </div>
              <div className="row">
                <DateSelector
                  className="filter_group"
                  value={form.startDate}
                  onChange={(itemValue) => updateForm(itemValue, "startDate")}
                  startYear={2023}
                  endYear={year}
                />
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-4">
            <div className="input_item">
              <div className="name">
                <i className="far fa-calendar-alt"></i> {__("End Day")}
              </div>
              <div className="row">
                <DateSelector
                  className="filter_group"
                  value={form.endDate}
                  onChange={(itemValue) => updateForm(itemValue, "endDate")}
                  startYear={2023}
                  endYear={year}
                />
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="button_group">
              <Link
                hrefLang={Translator.getSelectedLanguage().code}
                to="#"
                onClick={getResults}
                className="commonBtn pTwoBtn"
              >
                {__("Search")}
              </Link>
              <Link
                hrefLang={Translator.getSelectedLanguage().code}
                to="#"
                onClick={doReset}
                className="commonBtn pTwoBtn red"
              >
                {__("Reset")}
              </Link>
            </div>
          </div>
        </div>
        <div className="table_area">
          <div className="d-none d-sm-block">
            <div className="heading_row transaction_history">
              <div className="item">{__("Type")}</div>
              <div className="item">{__("Date")}</div>
              <div className="item">{__("Amount")}</div>
              <div className="item">{__("Method")}</div>
            </div>

            {results.length ? (
              <>
                {results.map((item, index) => (
                  <div key={index} className="data_row transaction_history">
                    <div className="item">
                      {item.type === "Deposit" ? (
                        <>
                          {item.status_code == 1 ? (
                            <span className="action_icon">
                              <i className="far fa-check"></i>
                            </span>
                          ) : (
                            <span className="action_icon error">
                              <i className="far fa-times"></i>
                            </span>
                          )}
                        </>
                      ) : (
                        <>
                          {item.status_code == 1 ? (
                            <span className="action_icon">
                              <i className="far fa-check"></i>
                            </span>
                          ) : (
                            <span className="action_icon error">
                              <i className="far fa-times"></i>
                            </span>
                          )}
                        </>
                      )}

                      {item.type}
                    </div>
                    <div className="item">{item.action_date}</div>
                    <div className="item">
                      <b>{item.amount}</b>
                    </div>
                    <div className="item">
                      <span className="table_btn radius_5">{item.method}</span>
                    </div>
                  </div>
                ))}

                <Pagination data={pagination} onPageChange={onPageChange} />
              </>
            ) : (
              <NoRecordsFound />
            )}
          </div>

          <div className="mobile_accordion d-block d-sm-none">
            {results.length ? (
              <>
                <Accordion>
                  {results.map((item, index) => (
                    <Accordion.Item eventKey={index} key={index}>
                      <Accordion.Header>{item.type}</Accordion.Header>
                      <Accordion.Body>
                        <div className="accordion_content">
                          <div className="input_item">
                            <div className="name">{__("Type")}</div>
                            <div className="form-control name_value">{item.type}</div>
                          </div>
                          <div className="input_item">
                            <div className="name">{__("Date")}</div>
                            <div className="form-control name_value">{item.action_date}</div>
                          </div>
                          <div className="input_item">
                            <div className="name">{__("Amount")}</div>
                            <div className="form-control name_value">{item.amount}</div>
                          </div>

                          <div className="input_item">
                            <div className="name">{__("Method")}</div>
                            <div className="form-control name_value">{item.method}</div>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>

                <br />
                <br />

                <Pagination data={pagination} onPageChange={onPageChange} />
              </>
            ) : (
              <NoRecordsFound />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
